import type {
  ForecastBasis,
  ForecastPeriod,
  ForecastPublic,
  ForecastSummaryPublic,
} from "@common/client"
import {
  formatShortDate,
  toDateInputValue,
  todayInputValue,
} from "@common/lib/date-utils"
import { addDays } from "date-fns"

export const BASES = ["average_utilization", "planned_utilization"] as const

export const UNAVAILABLE_BASES: readonly ForecastBasis[] = [
  "planned_utilization",
]

export const BASIS_LABELS: Record<ForecastBasis, string> = {
  average_utilization: "Average utilisation",
  planned_utilization: "Planned schedule",
}

export const DEFAULT_PERIOD_DAYS = 90

export const MAXIMUM_PERIOD_DAYS = 3650

export function periodFromToday(days: number): ForecastPeriod {
  return {
    starts_on: todayInputValue(),
    ends_on: toDateInputValue(addDays(new Date(), days)),
  }
}

export function periodText(period: ForecastPeriod): string {
  return `${formatShortDate(period.starts_on)} – ${formatShortDate(period.ends_on)}`
}

export function scopeText(
  forecast: ForecastPublic,
  summary: ForecastSummaryPublic | undefined,
): string {
  switch (forecast.scope.kind) {
    case "fleet":
      return summary ? `Fleet · ${summary.aircraft}` : "Fleet"
    case "aircraft": {
      const { registrations } = forecast
      return registrations.length <= 2
        ? registrations.join(", ")
        : `${registrations.length} aircraft`
    }
  }
}
